module.exports = __webpack_public_path__ + "bcb0ccfb64e52fb5bf0cb2b934e60857.png";